import ControlsFiltersGenders from './ControlsFiltersGenders';

const ControlsFilters = () => (
  <div className='flex items-end space-x-2'>
    <ControlsFiltersGenders />
  </div>
);

export default ControlsFilters;
